// 繁體中文語言包
export const zhTW = {
  brand: { name: 'Escalote', full: '緊急事件通知升級系統', tagline: '訊息 · 逾時 · 電話叫醒 · 逐級升級' },
  common: {
    save: '儲存', cancel: '取消', confirm: '確定', create: '新增', edit: '編輯', delete: '刪除', deleted: '已刪除',
    crash: '頁面渲染錯誤', backHome: '返回指揮台', retry: '重試本頁面', on: '開', off: '關',
    close: '關閉', search: '搜尋', reset: '重設', all: '全部', loading: '載入中…', actions: '操作',
    status: '狀態', severity: '級別', title: '標題', description: '描述', language: '語言',
    timezone: '時區', logout: '登出', refresh: '重新整理', copy: '複製', copied: '已複製',
    required: '必填', optional: '選填', system: '系統', name: '姓名', phone: '電話', email: '電子信箱', role: '角色',
    position: '順序', customer: '客戶', service: '服務', category: '問題類型', keyword: '關鍵字', source: '來源',
    createdAt: '登記時間', resolvedAt: '解決時間', closedAt: '關閉時間', ackAt: '首次回應',
    readAt: '首次已讀', note: '批註', total: '共 {{count}} 筆', minutesUnit: '分鐘', timesUnit: '次',
    back: '返回', view: '檢視', enabled: '啟用', disabled: '停用', yes: '是', no: '否', none: '無', operator: '操作者', lastActive: '最近心跳',
    range: { d7: '近 7 天', d14: '近 14 天', d30: '近 30 天', d90: '近 90 天', all: '不限' },
    error: {
      GENERIC: '操作失敗，請重試', NETWORK: '網路錯誤，無法連線伺服器',
      BAD_CREDENTIALS: '帳號或密碼錯誤', UNAUTHORIZED: '登入已過期，請重新登入',
      NOTE_REQUIRED: '請填寫批註說明', INVALID_TRANSITION: '不允許的狀態流轉',
      SAME_STATUS: '事件已處於該狀態', SCOPE_DENIED: '無權存取該服務',
      RATE_LIMITED: '嘗試次數過多，請稍後再試', FORBIDDEN: '權限不足',
      NO_WECOM_USER: '該企業微信帳號未在系統中登記，請聯絡管理員',
      WECOM_AUTH_FAILED: '企業微信授權失敗，請重試', LINK_EXPIRED: '連結已過期，請重新登入',
      INVALID_API_KEY: '服務代碼或 API Key 無效', USER_DISABLED: '帳號已被停用',
    },
  },
  nav: {
    dashboard: '指揮台', events: '事件中心', services: '服務目錄', customers: '客戶管理',
    categories: '問題類型', users: '使用者與權限', audit: '稽核紀錄', settings: '系統設定',
    mobileHub: '行動裝置演練',
  },
  auth: {
    signIn: '登入指揮台', signBtn: '登 入', username: '帳號', password: '密碼',
    tabPassword: '帳號密碼', tabQr: '掃碼登入', autoSignIn: '企業微信一鍵登入',
    qrHint: '使用企業微信或已綁定的個人微信掃描二維碼；首次使用需管理員在企業微信後台設定可信網域',
    err: {
      WECOM_AUTH_FAILED: '企業微信授權失敗，請重試或使用帳號密碼登入',
      NO_WECOM_USER: '您的企業微信帳號尚未在本系統建檔，請聯絡管理員開通',
    },
    mockTitle: '企業微信身分模擬（演示）', mockHint: '點擊下方身分即可免密登入，模擬值班人員收到告警後的處理過程',
    signing: '登入中…', poweredBy: '基於企業微信 · 支援中／繁／英與多時區協作',
  },
  status: { open: '待處理', acknowledged: '已回應', in_progress: '處理中', resolved: '已解決', closed: '已結案', cancelled: '已取消' },
  severity: { P1: 'P1 · 危急', P2: 'P2 · 嚴重', P3: 'P3 · 一般' },
  tier: { t1: '一線值班', t2: '二線值班', t3: '管理層', chain: '升級層級', endedShort: '已終止' },
  source: { api: 'API 回報', manual: '人工建單' },
 dashboard: {
    hello: '指揮台總覽', window: '時間區間', filters: '篩選',
    kpi: {
      total: '事件總數', active: '處理中事件', p1: 'P1 危急事件', unacked: '無人回應',
      ackRate: '回應涵蓋率', avgResp: '平均首次回應', avgResolve: '平均解決時間',
    },
    trend: '事件趨勢（依登記日・檢視時區）', dimCustomer: '依客戶統計', dimService: '依服務統計', dimCategory: '依問題類型統計',
    dimPerson: '人員處理統計', colCount: '事件數', colActive: '未結案', colAvgResp: '平均首響', colAvgResolve: '平均解決',
    person: { ackCount: '回應次數', resolvedCount: '解決次數', notified: '被通知數' },
    top: {
      title: 'Top 10 時效榜', kindResponse: '首次回應', kindResolve: '處理時長',
      best: '最快 Top10', worst: '最慢 Top10', empty: '暫無符合條件的事件',
    },
    empty: '該時間區間內沒有事件資料',
  },
  events: {
    listTitle: '事件中心', newEvent: '人工建單', mine: '我值班的', uuid: '事件 UUID',
    filterStatus: '狀態', filterSeverity: '級別', filterService: '服務', filterCustomer: '客戶', filterCategory: '類型',
    colRaised: '登記時間', colFirstResp: '首響', colResolution: '解決時間', colTier: '升級層級', colAckUser: '響應人',
    detailTitle: '事件詳情', basic: '基本資訊', timeline: '處理時間線', notes: '通知與呼叫紀錄',
    roster: '值班配置', noRoster: '該服務暫未配置值班人員',
    act: {
      ack: '確認接單', start: '開始處理', resolve: '標記解決', close: '結案', cancel: '誤報取消', reopen: '重新開啟',
      ackNotePh: '說明你正在接手處理（必填）', in_progressNotePh: '說明開始處理的內容（必填）',
      resolveNotePh: '說明根因與處理結果（必填）', closeNotePh: '確認結案的說明（必填）',
      cancelNotePh: '說明誤報判定原因（必填）',
    },
    modalAckTitle: '確認接單', modalStatusTitle: '狀態流轉 · {{to}}',
    escalationBanner: {
      tier1: '已通知一線值班，等待確認', tier2: '一線逾時未回應 — 已升級二線', tier3: '一／二線均未回應 — 已電話輪呼管理員',
      done: '升級鏈已終止（已有人回應或事件結束）', waiting: '升級引擎監控中',
    },
    demoLink: '模擬點擊企業微信卡片（免密跳轉演練）', reboost: '重新引導通知（超管）',
    notifyCols: { target: '接收人', channel: '管道', lang: '語言', result: '結果', sentAt: '發送時間' },
    channel: { wecom_textcard: '企業微信卡片', wecom_markdown: '企業微信訊息', voice_call: '語音電話' },
    notifStatus: { sent: '已送達', pending: '發送中', failed: '失敗', read: '已讀', cancelled: '已取消', answered: '已接聽', no_answer: '未接聽' },
    call: { answered: '已接聽', missed: '未接聽', dialing: '撥打中', inCall: '通話中', dialFailed: '呼叫失敗' },
    createTitle: '人工登記緊急事件', createOk: '事件已登記，升級鏈已啟動',
    deleteConfirm: '刪除該事件？將連同時間線、通知、任務、呼叫記錄一併徹底刪除，不可恢復',
    batchDeleteConfirm: '確認刪除選中的 {count} 條事件？將連同其全部關聯記錄徹底刪除，不可恢復',
    deleteSelected: '刪除選中', deletedN: '已刪除 {count} 條事件',
  },
  timeline: {
    create: '事件登記', notified: '已通知值班', read: '訊息已讀', acknowledged: '確認回應',
    in_progress: '開始處理', resolved: '問題解決', closed: '事件結案', cancelled: '誤報取消',
    escalate: '升級通知', escalate_pending: '逾時升級', voice_call: '語音呼叫',
    no_assignee: '層級無人值班', voice_exhausted: '語音重試已用盡',
    admin_rotation_start: '管理員電話輪呼開始', admin_rotation_exhausted: '輪呼達上限仍無人回應',
    voice_stopped: '接聽即停輪呼',
  },
  services: {
    title: '服務目錄', code: '服務代碼', name: '服務名稱', desc: '說明', apiKeyHint: 'Key 前綴',
    create: '新增服務', createOk: '服務建立成功', detail: '服務配置',
    keyOnceTitle: '請立即儲存 API Key', keyOnceBody: '基於安全考量，系統僅顯示一次明文。若遺失請輪換。',
    rotate: '輪換 API Key', rotateOk: '舊 Key 進入寬限期（雙 Key 並行），新 Key 僅顯示一次',
    assignees: '值班人員', addAssignee: '新增值班人', orderInTier: '輪轉順序', removeConfirm: '移除該值班關係？',
    deleteConfirm: '刪除該服務？其值班分配與策略將一併刪除；已有事件記錄的服務不可刪除（請改用停用）',
    noAssigneeWarn: '目前層級無人：升級時該層級會被跳過',
    policy: '升級策略', policyGlobal: '全域預設策略', policyService: '本服務覆蓋策略', policyHint: '未設定＝使用全域預設',
    p: {
      readTimeout: '未讀轉語音逾時', ackTimeout: '升級下層逾時', voiceRetries: '語音呼叫次數',
      voiceInterval: '語音呼叫間隔', adminInterval: '管理員輪呼間隔', adminMaxCycles: '輪呼最大圈數',
      stopOnAnswer: '接聽後停止輪呼', stopOnAnswerTip: '值班人接聽電話成功即視為已叫醒，取消本層級剩餘語音輪呼；升級推進仍以確認接單（批注回應）為準',
    },
    cols: { customer: '所屬客戶', assignees: '值班人數', status: '狀態' },
    savedOk: '已儲存',
  },
  customers: {
    title: '客戶管理', code: '客戶代碼', nameCn: '名稱（簡）', nameTw: '名稱（繁）', nameEn: '名稱（英）', tz: '預設時區', remark: '備註',
    export: '匯出 CSV', import: '匯入 CSV', importTitle: '匯入客戶（CSV）',
    importHint: '表頭須包含以下欄位（僅 code、name_zh_cn 必填），已存在的 code 將被更新：',
    importResult: '匯入結果', importStat: '共 {{total}} 列：新增 {{created}}，更新 {{updated}}',
    delConfirm: '確認刪除客戶 {{code}}？此操作無法復原',
  },
  categories: { title: '問題類型', code: '類型代碼', sort: '排序' },
  users: {
    title: '使用者與權限', create: '新增使用者', wecom: '企業微信 UserID', password: '登入密碼（本機帳號）',
    roles: { super_admin: '超級管理員', service_admin: '服務管理員', responder: '值班人員', viewer: '唯讀稽核' },
    roleHint: '角色決定後台權限；值班關係決定可見服務', resetPwd: '重設密碼（留空不变更）',
    disable: '停用', enable: '啟用', deleteConfirm: '確認刪除該用戶？有歷史留痕者會被拒絕',
    disableConfirm: '停用後該用戶無法登入/接收值班通知，確定？', enableConfirm: '恢復該用戶帳號？',
  },
  audit: { apiTitle: '對外 API 呼叫稽核', adminTitle: '管理操作稽核', when: '時間', method: '方法', path: '路徑', result: '結果', latency: '耗時', ip: '來源 IP', actor: '操作人', actionCol: '動作', target: '對象' },
  settings: {
    title: '系統設定', runtime: '執行環境', wecomMode: '企業微信通道', voiceMode: '語音通道', engine: '升級引擎',
    mockOn: '演示模式（mock）', httpOn: '生產模式（真實 API）', webhookOn: 'Webhook 呼叫平台', off: '關閉',
    base: '服務基地址', defaultPolicy: '預設升級策略', docs: '設計文件位於 repo 的 docs/ 目錄',
    profile: '個人資料', changePassword: '修改密碼', currentPwd: '當前密碼', newPwd: '新密碼（至少 8 位）',
    confirmPwd: '確認新密碼', pwdMismatch: '兩次輸入的新密碼不一致',
    relay: {
      title: '語音中繼裝置', hint: '專用安卓手機安裝 Relay App 並填入此處產生的令牌；多台互為備援——同一通話僅一台撥出，失敗或離線自動由其他裝置接手（最多 3 次嘗試）',
      add: '新增裝置', hintCol: '令牌', heartbeat: '狀態', online: '在線', idle: '寬限中', off: '已停用',
      offlineAlerted: '離線·已告警',
      dials: '累計撥號', rotate: '輪換令牌', rotateConfirm: '輪換後舊令牌立即失效，App 需重新填寫，確認？',
      delConfirm: '刪除該中繼裝置？', tokenOnce: '裝置令牌（明文僅顯示一次）',
      tokenOnceHint: '請立即複製到中繼手機 App 保存，本頁面無法再次查看。',
      nameExtra: '便於辨識的機身位置名稱', namePh: '如：前台中繼A / 辦公室備用機',
    },
  },
  mobile: {
    title: '我的緊急事件', empty: '目前沒有待處理事件，保持警覺 👀', detail: '事件處理',
    intro: '企業微信免密登入 · 點按即可完成回應', waitingEscalation: '升級鏈運行中',
    actNow: '立即處理', markRead: '標記已讀',
    countdownNote: '逾時未回應將自動升級並觸發語音電話',
  },
  layout: { collapsed: '收合導覽', expand: '展開導覽', tzView: '檢視時區' },
} as const;
